import { render, staticRenderFns } from "./SkillsConnectedWithCompetencesTab.vue?vue&type=template&id=4651df9e&scoped=true&"
import script from "./SkillsConnectedWithCompetencesTab.vue?vue&type=script&lang=js&"
export * from "./SkillsConnectedWithCompetencesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4651df9e",
  null
  
)

export default component.exports